module.exports = __webpack_public_path__ + "static/media/em.cc84788d.png";